import { NAVIGATION } from '@Constants/types';

const initialState = {
    isHeaderMenuOpened: false,
    currentTab: '',
    mixpanelTabLoadTimeStamp: null,
    mixpanelTabLoadDuration: 0
};

export default function headerNavigationReducer(state = initialState, action) {
    switch (action.type) {
        case NAVIGATION.HEADER_MENU_TOGGLE:
            return {
                ...state,
                isHeaderMenuOpened: action.payload
            };
        case NAVIGATION.CURRENT_TAB:
            return {
                ...state,
                currentTab: action.payload,
                mixpanelTabLoadTimeStamp: new Date()
            };
        case NAVIGATION.PAGE_LOADED:
            const mixpanelStartTimeStamp = state.mixpanelTabLoadTimeStamp;
            const mixpanelEndTimeStamp = new Date();
            const durationInMilliseconds =
                mixpanelEndTimeStamp.getTime() - mixpanelStartTimeStamp.getTime();
            return {
                ...state,
                mixpanelTabLoadDuration: durationInMilliseconds
            };

        default:
            return state;
    }
}
